import React, { Component } from 'react';

// Externals
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import styles from './styles'

// Material helpers
import { withStyles } from '@material-ui/core/styles';
// Material components
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
// Shared layouts
import DashboardLayout from 'layouts/Dashboard';
import SpecialObjective from './components/SpecialObjective'
import NoActive from '../../helpers/NoActive';
import WaitServer from '../../utils/WaitServer'
import Legacy from './components/Legacy'
import LegacyExcel from './components/LegacyExcel'
import {getSpecial} from '../../services/specials/getSpecial'
import NoData from '../../helpers/NoData'
import { UptimeTable } from './components/UptimeTable';
import queryString from 'query-string';
import moment from 'moment';


class Special extends Component {
    constructor(props) {
        
        super(props);
        this.myCallback = this.myCallback.bind(this);
        this.state = {
            nameObjective: this.props.match.params.nombre_objetivo,
            objective:this.props.match.params.objetivo_id,
            error:false,
            listSpecial:{'under':<NoActive/>, 'comparativeSpecial':<SpecialObjective data={this.props} method='comparativeSpecial'/>,
                        'comparativeObjective':<SpecialObjective data={this.props} method='comparativeObjective'/>,
                        'legacy':<Legacy data={this.props} method='legacy'/>,'noData':<NoData/>,
                        'legacyExcel':<LegacyExcel data={this.props} method='legacyExcel'/>,
                        'dailyAvailabilitySummary': <UptimeTable data={this.props}/>},
            load:true
        }
    }
    myCallback = (dataFromChild) => {
        this.setState({
            listObjectivesSpecials: dataFromChild
        })
    }

    componentDidMount() {
        this.getDataFromAPI();
    }

    getDataFromAPI=()=>{
        const {objective, listSpecial}=this.state
        const token = sessionStorage.getItem('key')
        const user = sessionStorage.getItem('user')
        
        const startDate = moment().subtract({"months":1}).startOf('month')
        let month = startDate.month() + 1
        let year = startDate.year()
        const parsedQuertSearch = queryString.parse(this.props.location.search)
        if (parsedQuertSearch) {
            month = parsedQuertSearch?.month ?? month
            year = parsedQuertSearch?.year ?? year
        }
        getSpecial(objective,user, token, month, year).then( value =>{
            try {
                if(typeof(value)=='string'){
                    this.setState({
                        container: <NoActive />,
                        load:false,
                    });
                }else{
                    if(value.validConfig===false){
                        this.setState({
                            container: listSpecial.noData,
                            load:false
                        });
                    }else{
                        sessionStorage.setItem("specialObjectiveData", JSON.stringify(value))
                        sessionStorage.setItem("methodSpecial",value.method)
                        sessionStorage.setItem("scheduleSpecial",JSON.stringify(value.horario))
                        sessionStorage.setItem("setupSpecial",JSON.stringify(value.setup))
                        sessionStorage.setItem("objetivosSpecial",JSON.stringify(value.objetivos.map(ele=>({"nombre":ele.nombre, 'id':ele.objetivo_id}))))
                        sessionStorage.setItem("objetivoConfigSpecial",JSON.stringify(value.config_objetivo))
                        sessionStorage.setItem("typesSpecial",JSON.stringify(value.tipos))
                        this.setState({
                            container: listSpecial[value.method],
                            load:false
                        });
                    }
                    
                    
                } 
            } catch (error) {
                this.setState({
                    error: true,
                    load:false
                });
            }
        })
            
    }
    render() {
        const {container, load}=this.state
        if(load===true){
            return (
                <DashboardLayout title="Especial" subtitle="Servicio" callbackFromParent={this.myCallback}>
                <WaitServer />
              </DashboardLayout>
            )
        }else{
            return (
                <DashboardLayout title="Especial" subtitle="Servicio" callbackFromParent={this.myCallback}>
                    <Grid
                        container
                        style={{margin:"0px", padding: '40px', paddingBottom: 0}}
                    >
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            xl={12}
                        >
                            <Typography
                                variant="h5"
                                style={{color:"white"}}
                            >
                                {container}
                            </Typography>
                        </Grid>
                    </Grid>
                </DashboardLayout>
            );
        }
        
    }
}


Special.propTypes = {
    classes: PropTypes.object.isRequired
};
export default compose( withStyles(styles))(Special);